(function(){
  var MONTHS = ['January','February','March','April','May','June','July','August','September','October','November','December'];
  function pad(n){ return String(Math.max(0, n)).padStart(2,'0'); }
  function $(s, r){ return (r||document).querySelector(s); }
  function $all(s, r){ return Array.prototype.slice.call((r||document).querySelectorAll(s)); }

  function init(){
    var root = $('.nt');
    if (!root || root.__ntInit) return;
    root.__ntInit = true;

    /* ---- zoom fit ---- */
    function fitScale(){
      var w = document.documentElement.clientWidth;
      root.style.zoom = (w >= 769 && w <= 1439) ? String(w / 1440)
        : (w >= 421 && w <= 768) ? String(Math.min(w, 600) / 420)
        : '';
    }
    fitScale();
    setTimeout(fitScale, 200);
    window.addEventListener('resize', fitScale);

    /* ---- billing date (+7 days) ---- */
    var bd = new Date(Date.now() + 7 * 86400000);
    var billText = MONTHS[bd.getMonth()] + ' ' + bd.getDate();
    $all('[data-nt-billdate]').forEach(function(el){ el.textContent = billText; });

    /* ---- countdown (evergreen, per-visitor; auto-restarts at 0) ---- */
    var CD_DUR = 3 * 24 * 3600 * 1000; /* 3 days */
    var deadline = null;
    try { deadline = Number(localStorage.getItem('nass-trial-deadline')) || null; } catch(e){}
    function resetDeadline(){
      deadline = Date.now() + CD_DUR;
      try { localStorage.setItem('nass-trial-deadline', String(deadline)); } catch(e){}
    }
    if (!deadline || deadline <= Date.now()) resetDeadline();
    function setCd(id, v){ var el = document.getElementById(id); if (el && el.textContent !== v) el.textContent = v; }
    function tick(){
      if (Date.now() >= deadline) resetDeadline(); /* hit 0 -> restart the 3-day window live */
      var sec = Math.max(0, Math.floor((deadline - Date.now()) / 1000));
      setCd('nt-cd-d', pad(Math.floor(sec / 86400)));
      setCd('nt-cd-h', pad(Math.floor(sec / 3600) % 24));
      setCd('nt-cd-m', pad(Math.floor(sec / 60) % 60));
      setCd('nt-cd-s', pad(sec % 60));
    }
    tick();
    setInterval(tick, 1000);

    /* ---- modal ---- */
    var wrap = $('.nt-modal-wrap');
    function modalOpen(){ return wrap && wrap.classList.contains('is-open'); }
    function openModal(){ if (!wrap) return; wrap.classList.add('is-open'); document.body.style.overflow = 'hidden'; syncSticky(); }
    function closeModal(){ if (!wrap) return; wrap.classList.remove('is-open'); document.body.style.overflow = ''; syncSticky(); }
    $all('[data-nt-open]').forEach(function(b){ b.addEventListener('click', function(e){ if (e.preventDefault) e.preventDefault(); openModal(); }); });
    if (wrap){
      wrap.addEventListener('click', function(e){
        if (e.target === wrap) { closeModal(); return; }         /* backdrop only */
        if (e.target.closest('[data-nt-close]')) closeModal();   /* the X control */
      });
    }

    /* ---- refund & cancellation policy window ---- */
    var refundWrap = $('.nt-refund-wrap');
    function openRefund(){ if (!refundWrap) return; refundWrap.classList.add('is-open'); document.body.style.overflow = 'hidden'; refundWrap.scrollTop = 0; }
    function closeRefund(){ if (!refundWrap) return; refundWrap.classList.remove('is-open'); document.body.style.overflow = ''; }
    $all('[data-nt-refund-open]').forEach(function(b){ b.addEventListener('click', function(e){ if (e.preventDefault) e.preventDefault(); openRefund(); }); });
    if (refundWrap){
      refundWrap.addEventListener('click', function(e){
        if (e.target === refundWrap) { if (e.preventDefault) e.preventDefault(); closeRefund(); return; }  /* backdrop only */
        if (e.target.closest('[data-nt-refund-close]')) { if (e.preventDefault) e.preventDefault(); closeRefund(); }  /* back link */
      });
    }

    /* ---- generic legal doc windows (subscription terms, privacy policy) ---- */
    $all('.nt-doc-wrap').forEach(function(w){
      w.addEventListener('click', function(e){
        if (e.target === w || (e.target.closest && e.target.closest('[data-nt-doc-close]'))) {  /* backdrop or back link */
          if (e.preventDefault) e.preventDefault();
          w.classList.remove('is-open'); document.body.style.overflow = '';
        }
      });
    });
    $all('[data-nt-doc-open]').forEach(function(b){ b.addEventListener('click', function(e){
      if (e.preventDefault) e.preventDefault();
      var w = $('.nt-doc-wrap[data-nt-doc="' + b.getAttribute('data-nt-doc-open') + '"]');
      if (!w) return;
      w.classList.add('is-open'); document.body.style.overflow = 'hidden'; w.scrollTop = 0;
    }); });

    /* ---- FAQ accordion open/close animation ---- */
    var faqReduce = (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    if (!faqReduce) {
      var FAQ_DUR = 280;
      $all('.nt-faq details').forEach(function(d){
        var sum = d.querySelector('summary');
        var body = sum && sum.nextElementSibling; /* the answer <p> */
        if (!sum || !body) return;
        var mt = getComputedStyle(body).marginTop;
        body.style.overflow = 'hidden';
        body.style.transition = 'height ' + FAQ_DUR + 'ms var(--ease-out), opacity ' + FAQ_DUR + 'ms var(--ease-out), margin-top ' + FAQ_DUR + 'ms var(--ease-out)';
        function collapse(){ body.style.height = '0px'; body.style.opacity = '0'; body.style.marginTop = '0px'; }
        if (!d.open) collapse();
        var busy = false;
        sum.addEventListener('click', function(e){
          e.preventDefault();
          if (busy) return;
          busy = true;
          if (d.open) {
            body.style.height = body.scrollHeight + 'px'; body.style.opacity = '1'; body.style.marginTop = mt;
            requestAnimationFrame(function(){ requestAnimationFrame(collapse); });
            setTimeout(function(){ d.open = false; busy = false; }, FAQ_DUR);
          } else {
            d.open = true;
            collapse();
            requestAnimationFrame(function(){ requestAnimationFrame(function(){
              body.style.height = body.scrollHeight + 'px'; body.style.opacity = '1'; body.style.marginTop = mt;
            }); });
            setTimeout(function(){ body.style.height = 'auto'; busy = false; }, FAQ_DUR);
          }
        });
      });
    }

    /* ---- sticky bar ---- */
    var sticky = $('.nt-sticky');
    var stickyDismissed = false;   /* dismiss hides it for this page view; it reappears on the next reload */
    function syncSticky(){
      if (!sticky) return;
      var on = !stickyDismissed && window.scrollY > window.innerHeight * 0.9 && !modalOpen();
      sticky.classList.toggle('is-on', on);
    }
    var stickyX = sticky && sticky.querySelector('[data-nt-sticky-dismiss]');
    if (stickyX) stickyX.addEventListener('click', function(){
      stickyDismissed = true;
      sticky.classList.remove('is-on');
      sticky.classList.add('is-dismissed');   /* also uncovers the chat launcher behind the bar */
    });
    window.addEventListener('scroll', syncSticky, { passive: true });
    syncSticky();

    /* ---- comparison tabs (mobile) ---- */
    var cmp = $('.nt-cmp');
    var tabs = $all('.nt-cmp-tabs button');
    if (cmp && tabs.length){
      var setTab = function(k){
        cmp.classList.toggle('is-nass', k === 'nass');
        tabs.forEach(function(b){ b.setAttribute('aria-selected', String(b.dataset.cmp === k)); });
      };
      tabs.forEach(function(b){ b.addEventListener('click', function(){ setTab(b.dataset.cmp); }); });
      setTab('nass');
    }

    /* ---- carousel ---- */
    var slideCount = 7, slide = 0, auto = null;
    var track = document.getElementById('nt-track');
    var car = $('.nt-carousel');
    function paint(){
      if (track) track.style.transform = 'translateX(' + (-slide * 100) + '%)';
      $all('.nt-dot').forEach(function(d){ d.classList.toggle('is-on', Number(d.dataset.i) === slide); });
    }
    function goSlide(i, user){
      slide = Math.max(0, Math.min(slideCount - 1, i));
      paint();
      if (user){ clearInterval(auto); auto = setInterval(advance, 5000); }
    }
    function advance(){ if (!document.hidden) goSlide(slide >= slideCount - 1 ? 0 : slide + 1); }
    paint();
    $all('.nt-dot').forEach(function(d){ d.addEventListener('click', function(){ goSlide(Number(d.dataset.i), true); }); });
    var prevBtn = $('[data-nt-prev]'); if (prevBtn) prevBtn.addEventListener('click', function(){ goSlide(slide - 1, true); });
    var nextBtn = $('[data-nt-next]'); if (nextBtn) nextBtn.addEventListener('click', function(){ goSlide(slide + 1, true); });
    auto = setInterval(advance, 5000);
    if (car){
      var x0 = 0, y0 = 0, dx = 0, dy = 0, lock = null;
      car.addEventListener('touchstart', function(e){
        var t = e.touches[0];
        x0 = t.clientX; y0 = t.clientY; dx = 0; dy = 0; lock = null;
        if (track) track.style.transition = 'none';
      }, { passive: true });
      car.addEventListener('touchmove', function(e){
        var t = e.touches[0];
        dx = t.clientX - x0; dy = t.clientY - y0;
        if (lock === null && (Math.abs(dx) > 8 || Math.abs(dy) > 8)) lock = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
        if (lock !== 'x') return;
        if (e.cancelable) e.preventDefault();
        var w = car.clientWidth || 1;
        var d = dx;
        if ((slide === 0 && d > 0) || (slide === slideCount - 1 && d < 0)) d *= 0.32;
        if (track) track.style.transform = 'translateX(' + (-slide * 100 + (d / w) * 100) + '%)';
      }, { passive: false });
      var end = function(){
        if (track) track.style.transition = '';
        if (lock === 'x' && Math.abs(dx) > Math.min(60, car.clientWidth * 0.18)) goSlide(slide + (dx < 0 ? 1 : -1), true);
        else paint();
        lock = null;
      };
      car.addEventListener('touchend', end, { passive: true });
      car.addEventListener('touchcancel', end, { passive: true });
    }

    /* ---- Plan A/B (no-restart) lite toggle ---- */
    var lite = $('[data-nt-lite-root]');
    var liteAuto = null, liteSwapT = null;
    function swapLite(){
      if (!lite || liteSwapT) return;
      lite.classList.add('nt-swapping');
      liteSwapT = setTimeout(function(){
        liteSwapT = null;
        lite.classList.remove('nt-swapping');
        lite.classList.toggle('is-lite');
      }, 380);
    }
    function startLiteAuto(){ clearInterval(liteAuto); liteAuto = setInterval(swapLite, 6000); }
    if (lite){
      var liteToggle = $('[data-nt-lite-toggle]');
      if (liteToggle) liteToggle.addEventListener('click', function(){ startLiteAuto(); swapLite(); });
    }

    /* ---- app screenshots cycle ---- */
    var shotAuto = null, shot = 0;
    function cycleShots(){
      shot = (shot + 1) % 3;
      $all('[data-shot]').forEach(function(el){ el.style.opacity = (Number(el.dataset.shot) === shot) ? '1' : '0'; });
    }

    /* ---- lazy videos ---- */
    function silence(v){ v.muted = true; v.defaultMuted = true; v.volume = 0; v.loop = true; v.playsInline = true; }
    document.addEventListener('volumechange', function(e){ if (e.target && e.target.tagName === 'VIDEO'){ e.target.muted = true; e.target.volume = 0; } }, true);
    document.addEventListener('play', function(e){ if (e.target && e.target.tagName === 'VIDEO'){ e.target.muted = true; e.target.volume = 0; } }, true);
    function mountVideos(){
      var vids = $all('video[data-src]');
      if (!('IntersectionObserver' in window)){
        vids.forEach(function(v){ silence(v); v.src = v.dataset.src; v.play().catch(function(){}); });
        return;
      }
      var io = new IntersectionObserver(function(es){
        es.forEach(function(e){
          var v = e.target;
          if (e.isIntersecting){
            silence(v);
            if (!v.src){ v.preload = 'auto'; v.src = v.dataset.src; }
            v.play().catch(function(){});
          } else if (!v.paused){ v.pause(); }
        });
      }, { rootMargin: '400px 200px' });
      vids.forEach(function(v){ io.observe(v); });
    }

    /* ---- consent form / checkout ---- */
    var emailInput = $('[data-nt-email]');
    var emailErr = $('[data-nt-emailerr]');
    var submitBtn = $('[data-nt-submit]');
    var submittedMsg = $('[data-nt-submitted]');
    var consent = { 1:false, 2:false, 3:false };
    // ---- Email validation ported 1:1 from nass-prenatal-quiz.js (isValidEmail):
    // ASCII-only, no consecutive dots, no punycode/IDN, TLD must be a real IANA
    // zone (kills junk like .qw), plus a brand-lock guard (rejects 1233gmail.co).
    var TLDS = ' aaa aarp abb abbott abbvie abc able abogado abudhabi ac academy accenture accountant accountants aco actor ad ads adult ae aeg aero aetna af afl africa ag agakhan agency ai aig airbus airforce airtel akdn al alibaba alipay allfinanz allstate ally alsace alstom am amazon americanexpress americanfamily amex amfam amica amsterdam analytics android anquan anz ao aol apartments app apple aq aquarelle ar arab aramco archi army arpa art arte as asda asia associates at athleta attorney au auction audi audible audio auspost author auto autos aw aws ax axa az azure ba baby baidu banamex band bank bar barcelona barclaycard barclays barefoot bargains baseball basketball bauhaus bayern bb bbc bbt bbva bcg bcn bd be beats beauty beer berlin best bestbuy bet bf bg bh bharti bi bible bid bike bing bingo bio biz bj black blackfriday blockbuster blog bloomberg blue bm bms bmw bn bnpparibas bo boats boehringer bofa bom bond boo book booking bosch bostik boston bot boutique box br bradesco bridgestone broadway broker brother brussels bs bt build builders business buy buzz bv bw by bz bzh ca cab cafe cal call calvinklein cam camera camp canon capetown capital capitalone car caravan cards care career careers cars casa case cash casino cat catering catholic cba cbn cbre cc cd center ceo cern cf cfa cfd cg ch chanel channel charity chase chat cheap chintai christmas chrome church ci cipriani circle cisco citadel citi citic city ck cl claims cleaning click clinic clinique clothing cloud club clubmed cm cn co coach codes coffee college cologne com commbank community company compare computer comsec condos construction consulting contact contractors cooking cool coop corsica country coupon coupons courses cpa cr credit creditcard creditunion cricket crown crs cruise cruises cu cuisinella cv cw cx cy cymru cyou cz dad dance data date dating datsun day dclk dds de deal dealer deals degree delivery dell deloitte delta democrat dental dentist desi design dev dhl diamonds diet digital direct directory discount discover dish diy dj dk dm dnp do docs doctor dog domains dot download drive dtv dubai dupont durban dvag dvr dz earth eat ec eco edeka edu education ee eg email emerck energy engineer engineering enterprises epson equipment er ericsson erni es esq estate et eu eurovision eus events exchange expert exposed express extraspace fage fail fairwinds faith family fan fans farm farmers fashion fast fedex feedback ferrari ferrero fi fidelity fido film final finance financial fire firestone firmdale fish fishing fit fitness fj fk flickr flights flir florist flowers fly fm fo foo food football ford forex forsale forum foundation fox fr free fresenius frl frogans frontier ftr fujitsu fun fund furniture futbol fyi ga gal gallery gallo gallup game games gap garden gay gb gbiz gd gdn ge gea gent genting george gf gg ggee gh gi gift gifts gives giving gl glass gle global globo gm gmail gmbh gmo gmx gn godaddy gold goldpoint golf goodyear goog google gop got gov gp gq gr grainger graphics gratis green gripe grocery group gs gt gu gucci guge guide guitars guru gw gy hair hamburg hangout haus hbo hdfc hdfcbank health healthcare help helsinki here hermes hiphop hisamitsu hitachi hiv hk hkt hm hn hockey holdings holiday homedepot homegoods homes homesense honda horse hospital host hosting hot hotels hotmail house how hr hsbc ht hu hughes hyatt hyundai ibm icbc ice icu id ie ieee ifm ikano il im imamat imdb immo immobilien in inc industries infiniti info ing ink institute insurance insure int international intuit investments io ipiranga iq ir irish is ismaili ist istanbul it itau itv jaguar java jcb je jeep jetzt jewelry jio jll jm jmp jnj jo jobs joburg jot joy jp jpmorgan jprs juegos juniper kaufen kddi ke kerryhotels kerryproperties kfh kg kh ki kia kids kim kindle kitchen kiwi km kn koeln komatsu kosher kp kpmg kpn kr krd kred kuokgroup kw ky kyoto kz la lacaixa lamborghini lamer land landrover lanxess lasalle lat latino latrobe law lawyer lb lc lds lease leclerc lefrak legal lego lexus lgbt li lidl life lifeinsurance lifestyle lighting like lilly limited limo lincoln link live living lk llc llp loan loans locker locus lol london lotte lotto love lpl lplfinancial lr ls lt ltd ltda lu lundbeck luxe luxury lv ly ma madrid maif maison makeup man management mango map market marketing markets marriott marshalls mattel mba mc mckinsey md me med media meet melbourne meme memorial men menu merck merckmsd mg mh miami microsoft mil mini mint mit mitsubishi mk ml mlb mls mm mma mn mo mobi mobile moda moe moi mom monash money monster mormon mortgage moscow moto motorcycles mov movie mp mq mr ms msd mt mtn mtr mu museum music mv mw mx my mz na nab nagoya name navy nba nc ne nec net netbank netflix network neustar new news next nextdirect nexus nf nfl ng ngo nhk ni nico nike nikon ninja nissan nissay nl no nokia norton now nowruz nowtv np nr nra nrw ntt nu nyc nz obi observer office okinawa olayan olayangroup ollo om omega one ong onl online ooo open oracle orange org organic origins osaka otsuka ott ovh pa page panasonic paris pars partners parts party pay pccw pe pet pf pfizer pg ph pharmacy phd philips phone photo photography photos physio pics pictet pictures pid pin ping pink pioneer pizza pk pl place play playstation plumbing plus pm pn pnc pohl poker politie porn post pr praxi press prime pro prod productions prof progressive promo properties property protection pru prudential ps pt pub pw pwc py qa qpon quebec quest racing radio re read realestate realtor realty recipes red redumbrella rehab reise reisen reit reliance ren rent rentals repair report republican rest restaurant review reviews rexroth rich richardli ricoh ril rio rip ro rocks rodeo rogers room rs rsvp ru rugby ruhr run rw rwe ryukyu sa saarland safe safety sakura sale salon samsclub samsung sandvik sandvikcoromant sanofi sap sarl sas save saxo sb sbi sbs sc scb schaeffler schmidt scholarships school schule schwarz science scot sd se search seat secure security seek select sener services seven sew sex sexy sfr sg sh shangrila sharp shell shia shiksha shoes shop shopping shouji show si silk sina singles site sj sk ski skin sky skype sl sling sm smart smile sn sncf so soccer social softbank software sohu solar solutions song sony soy spa space sport spot sr srl ss st stada staples star statebank statefarm stc stcgroup stockholm storage store stream studio study style su sucks supplies supply support surf surgery suzuki sv swatch swiss sx sy sydney systems sz tab taipei talk taobao target tatamotors tatar tattoo tax taxi tc tci td tdk team tech technology tel temasek tennis teva tf tg th thd theater theatre tiaa tickets tienda tips tires tirol tj tjmaxx tjx tk tkmaxx tl tm tmall tn to today tokyo tools top toray toshiba total tours town toyota toys tr trade trading training travel travelers travelersinsurance trust trv tt tube tui tunes tushu tv tvs tw tz ua ubank ubs ug uk unicom university uno uol ups us uy uz va vacations vana vanguard vc ve vegas ventures verisign versicherung vet vg vi viajes video vig viking villas vin vip virgin visa vision viva vivo vlaanderen vn vodka volvo vote voting voto voyage vu wales walmart walter wang wanggou watch watches weather weatherchannel web webcam weber website wed wedding weibo weir wf whoswho wien wiki williamhill win windows wine winners wme woodside work works world wow ws wtc wtf xbox xerox xihuan xin xxx xyz yachts yahoo yamaxun yandex ye yodobashi yoga yokohama you youtube yt yun za zappos zara zero zip zm zone zuerich zw ';
    var BRAND_OK = { 'gmail.com': 1, 'googlemail.com': 1, 'icloud.com': 1 };
    var BRAND_TOKENS = [{ t: 'googlemail', d: 'gmail.com' }, { t: 'gmail', d: 'gmail.com' }, { t: 'icloud', d: 'icloud.com' }];
    function brandFix(domain){ if (BRAND_OK[domain]) return ''; for (var i = 0; i < BRAND_TOKENS.length; i++) if (domain.indexOf(BRAND_TOKENS[i].t) > -1) return BRAND_TOKENS[i].d; return ''; }
    function isValidEmail(e){
      e = (e || '').trim().toLowerCase();
      if (!e || e.indexOf('..') > -1) return false;
      if (!/^[a-z0-9](?:[a-z0-9._%+-]*[a-z0-9])?@[a-z0-9](?:[a-z0-9-]*[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]*[a-z0-9])?)*\.[a-z]{2,}$/.test(e)) return false;
      var domain = e.slice(e.indexOf('@') + 1);
      if (domain.indexOf('xn--') > -1) return false;
      var tld = domain.slice(domain.lastIndexOf('.') + 1);
      if (TLDS.indexOf(' ' + tld + ' ') === -1) return false;
      if (brandFix(domain)) return false;
      return true;
    }
    function validEmail(){ return emailInput ? isValidEmail(emailInput.value) : false; }
    function refreshSubmit(){
      var ready = consent[1] && consent[2] && validEmail();
      if (submitBtn){
        submitBtn.disabled = !ready;
        submitBtn.classList.toggle('is-ready', ready);
      }
    }
    if (emailInput) emailInput.addEventListener('input', function(){ if (emailErr) emailErr.hidden = true; refreshSubmit(); });
    $all('[data-nt-consent]').forEach(function(row){
      row.addEventListener('click', function(){
        var k = row.getAttribute('data-nt-consent');
        consent[k] = !consent[k];
        var box = row.querySelector('.nt-cbx');
        if (box) box.classList.toggle('is-on', consent[k]);
        refreshSubmit();
      });
    });
    // Klaviyo client-side subscribe (company from theme settings, list UMrB7f — same as nass-email-signup)
    function ntKlaviyo(email){
      var root = document.querySelector('[data-nt-klaviyo-company]');
      var company = (root && root.getAttribute('data-nt-klaviyo-company') || '').trim();
      if (!company || !email) return Promise.resolve();
      return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(company), {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', 'Accept': 'application/vnd.api+json', 'revision': '2024-10-15' },
        body: JSON.stringify({ data: { type: 'subscription', attributes: { profile: { data: { type: 'profile', attributes: { email: email } } } }, relationships: { list: { data: { type: 'list', id: 'UMrB7f' } } } } })
      }).catch(function(){});
    }
    // Checkout hand-off: full-page form POST to /cart/add with return_to=/checkout.
    // One server navigation (add the subscription line + redirect to checkout,
    // atomically) — more robust than an AJAX add + window.location, which
    // cart-observing apps (OCU) could race or redirect, bouncing to the homepage.
    function ntStartCheckout(email, marketing){
      if (submitBtn) submitBtn.disabled = true;
      if (marketing && email) ntKlaviyo(email);
      // Straight to checkout. NB: Shopify's new one-page checkout does NOT prefill the
      // Contact email from a ?checkout[email]= URL param (it only routes Shop Pay
      // accounts), so we don't append it — the email is captured in the modal and sent
      // to Klaviyo. Real Contact prefill would require the Storefront API cart
      // (buyerIdentity.email + cart.checkoutUrl), which needs a Storefront access token.
      var returnTo = '/checkout';
      var f = document.createElement('form');
      f.method = 'post';
      f.action = '/cart/add';
      f.acceptCharset = 'UTF-8';
      function hidden(n, v){ var i = document.createElement('input'); i.type = 'hidden'; i.name = n; i.value = v; f.appendChild(i); }
      hidden('id', '44157567500362');
      // Appstle $7 -> $29/mo plan "Monthly Subscription" for nass-fit-app-membership-29.
      hidden('selling_plan', '4552130634');
      hidden('quantity', '1');
      hidden('return_to', returnTo);
      document.body.appendChild(f);
      f.submit();
    }
    if (submitBtn){
      submitBtn.addEventListener('click', function(){
        if (!validEmail()){ if (emailErr) emailErr.hidden = false; return; }
        if (!consent[1] || !consent[2]) return;
        ntStartCheckout(emailInput ? emailInput.value : '', !!consent[3]);
      });
    }
    refreshSubmit();

    /* ---- community signup (section 17) ---- */
    var signupEmail = $('[data-nt-signup-email]');
    var signupBtn = $('[data-nt-signup]');
    var signupOk = $('[data-nt-signup-ok]');
    function ntSignup(email){ return ntKlaviyo(email); }
    if (signupBtn){
      signupBtn.addEventListener('click', function(){
        var val = signupEmail ? signupEmail.value : '';
        if (!isValidEmail(val)) return;
        ntSignup(val);
        var rowEl = signupBtn.parentNode;
        if (rowEl) rowEl.hidden = true;
        if (signupOk) signupOk.hidden = false;
      });
    }

    /* ---- preloader boot ---- */
    var booted = false, preFallback = null, t0 = Date.now();
    function boot(){
      if (booted) return;
      booted = true;
      clearTimeout(preFallback);
      document.documentElement.classList.remove('nt-booting');
      var pre = document.getElementById('nt-pre');
      if (pre){
        pre.classList.add('nt-pre-done');
        setTimeout(function(){ if (pre.parentNode) pre.parentNode.removeChild(pre); }, 600);
      }
      mountVideos();
      startLiteAuto();
      shotAuto = setInterval(cycleShots, 4200);
    }
    document.documentElement.classList.add('nt-booting');
    function settled(el){
      return new Promise(function(res){
        if (!el || el.complete) return res();
        var done = function(){ res(); };
        el.addEventListener('load', done, { once: true });
        el.addEventListener('error', done, { once: true });
        setTimeout(done, 1200);
      });
    }
    var fonts = document.fonts ? document.fonts.ready.catch(function(){}) : Promise.resolve();
    var art = $all('.nt-carousel img:not([loading="lazy"]), header img').map(function(img){
      return settled(img).then(function(){ return (img.decode ? img.decode().catch(function(){}) : null); });
    });
    Promise.all([Promise.race([fonts, new Promise(function(r){ setTimeout(r, 1500); })])].concat(art))
      .then(function(){ return new Promise(function(r){ setTimeout(r, Math.max(0, 850 - (Date.now() - t0))); }); })
      .then(function(){ requestAnimationFrame(boot); });
    preFallback = setTimeout(boot, 2500);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
